import { render, staticRenderFns } from "./tel.vue?vue&type=template&id=1b5b1e42"
import script from "./tel.vue?vue&type=script&lang=js"
export * from "./tel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports